import React from 'react';
import './ParentSidebar.css';
import { ClipboardIcon, CalendarIcon, CreditCardIcon, ClockIcon, MailIcon, QuestionIcon } from './Icons';

function ParentSidebar({ activePage }) {
  const navigate = (page) => {
    if (window.navigateTo) {
      window.navigateTo(page);
    }
  };

  return (
    <aside className="parent-sidebar">
      <nav className="sidebar-nav">
        <a 
          href="#bulletin" 
          className={`nav-item ${activePage === 'parent-dashboard' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); navigate('parent-dashboard'); }}
        >
          <span className="nav-icon"><ClipboardIcon size={20} /></span>
          Bulletin de notes
        </a>
        
        <a 
          href="#emploi" 
          className={`nav-item ${activePage === 'emploi-du-temps' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); navigate('emploi-du-temps'); }}
        >
          <span className="nav-icon"><CalendarIcon size={20} /></span>
          Emploi du temps
        </a>
        
        <a 
          href="#payement" 
          className={`nav-item ${activePage === 'payement' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); navigate('payement'); }}
        >
          <span className="nav-icon"><CreditCardIcon size={20} /></span>
          Payement
        </a>
        
        <a 
          href="#historique" 
          className={`nav-item ${activePage === 'historique' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); navigate('historique'); }}
        >
          <span className="nav-icon"><ClockIcon size={20} /></span>
          Historique
        </a>
        
        <a 
          href="#contact-lycee" 
          className={`nav-item ${activePage === 'contact-lycee' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); navigate('contact-lycee'); }}
        >
          <span className="nav-icon"><MailIcon size={20} /></span>
          Écrire au lycée
        </a>
        
        <a 
          href="#support" 
          className={`nav-item ${activePage === 'support' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); navigate('support'); }}
        >
          <span className="nav-icon"><QuestionIcon size={20} /></span>
          Support et aides
        </a>
      </nav>
    </aside>
  );
}

export default ParentSidebar;
